import * as z from "zod/v4";

const URL_LIKE_PATTERN = /[:/.]/;

const companyIdSchema = z
  .string()
  .min(1, "Company ID is required")
  .refine((val) => !URL_LIKE_PATTERN.test(val), {
    message:
      "Company ID should be just the subdomain, not a full URL. For example, enter 'yourstore' instead of 'yourstore.app.apparelmagic.com'.",
  });

export const createOmsApparelMagicIntegration = {
  name: "createOmsApparelMagicIntegration" as const,
  input: z.object({ apiKey: z.string(), companyId: companyIdSchema }),
  output: z.object({ success: z.boolean() }),
};
